var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11699_3991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 -0.5C105.485 -0.5 107.5 1.51472 107.5 4V103C107.5 105.485 105.485 107.5 103 107.5H4C1.51472 107.5 -0.5 105.485 -0.5 103V4C-0.499999 1.51472 1.51472 -0.5 4 -0.5H103Z",
    fill: "#FFF3EE",
    stroke: "#FF8853"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11699_3991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.615 77.9997C31.3682 71.311 29 62.5802 29 53.4998C29 44.4195 31.3682 35.6887 35.615 29V77.9997Z",
    fill: "#FF8853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 78C71.5022 78 65.2705 75.4188 60.6759 70.8241C56.0812 66.2295 53.5 59.9978 53.5 53.5C53.5 47.0022 56.0812 40.7705 60.6759 36.1759C65.2705 31.5812 71.5022 29 78 29L78 78Z",
    fill: "#FF8853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7709 71.9938C46.275 74.667 49.2653 76.7017 52.52 77.9999V29C49.2653 30.2982 46.275 32.333 43.7709 35.0061C39.1762 39.911 36.595 46.5634 36.595 53.5C36.595 60.4365 39.1762 67.0889 43.7709 71.9938Z",
    fill: "#FF8853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11699_3991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    rx: 15.1059,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11699_3991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommContent);
export default __webpack_public_path__ + "static/media/CommContent.31eba4ea394ed6232a13a608b6f84aa3.svg";
export { ForwardRef as ReactComponent };